import { render } from "./page-content.vue?vue&type=template&id=f422840e"
import script from "./page-content.vue?vue&type=script&lang=js"
export * from "./page-content.vue?vue&type=script&lang=js"

import "./page-content.vue?vue&type=style&index=0&id=f422840e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__